// $Id: Shared.js,v 1.1 2005/11/05 16:32:00 vnagarjuna Exp $ -->

// Copyright 2005 Nagarjuna Venna <vnagarjuna@yahoo.com>
// See http://lekhini.org/scripts/padma-license.txt

// See http://lekhini.org/license.txt

//Shared across all scripts

export function Unicode_Shared() { }

Unicode_Shared.NUKTA    = "\u093C";
Unicode_Shared.AVAGRAHA = "\u093D";
Unicode_Shared.OM       = "\u0950";
Unicode_Shared.UDATTA   = "\u0951";
Unicode_Shared.ANUDATTA = "\u0952";
Unicode_Shared.SVARITA  = "\u0951";
Unicode_Shared.DANDA    = "\u0964";
Unicode_Shared.DDANDA   = "\u0965";
Unicode_Shared.abbrev   = "\u0970";
Unicode_Shared.ZWNJ     = "\u200C";
Unicode_Shared.ZWJ      = "\u200D";
